import moment from 'moment';

export const fetchNextBus = params => dispatch => {
    window.axios.get('/api/tcl').then(response => {
        dispatch({
            type: 'GET_NEXT_BUS',
            payload: response.data.nextBus,
        });
    });
};

export const fetchNextTrain = params => dispatch => {
    window.axios.get('/api/sncf').then(response => {
        let now = moment();

        if (response.data.nextTrain === undefined) {
            dispatch({
                type: 'GET_NEXT_TRAIN',
                payload: response.data.nextTrain,
            });

            return;
        }

        response.data.nextTrain.forEach(train => {
            if (train.times.length > 0) {
                train.times.sort();
                train.timeToWait = moment
                    .utc(train.times[0])
                    .diff(now, 'minutes');

                if (train.timeToWait > 120) {
                    train.timeToWait = '> 1h';
                } else {
                    train.timeToWait = train.timeToWait + ' min';
                }
            } else {
                train.timeToWait = 'NC';
            }
        });

        dispatch({
            type: 'GET_NEXT_TRAIN',
            payload: response.data.nextTrain,
        });
    });
};



// WEBPACK FOOTER //
// ./src/actions/transport.js